import React from "react";
import { Typography, Box, Grid } from "@mui/material";
import MemoryIcon from "@mui/icons-material/Memory";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import StorageIcon from "@mui/icons-material/Storage";
import SpeedIcon from "@mui/icons-material/Speed";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import DesignServicesIcon from "@mui/icons-material/DesignServices";

const features = [
  {
    icon: DesignServicesIcon,
    title: "Visual Canvas",
    description:
      "Drag and drop system components onto an infinite graph-paper canvas.",
  },
  {
    icon: SwapHorizIcon,
    title: "Traffic Simulation",
    description:
      "Simulate dynamic traffic patterns through your architecture in real-time.",
  },
  {
    icon: SpeedIcon,
    title: "Capacity Planning",
    description:
      "Configure TPS and capacity constraints to stress-test your system design.",
  },
  {
    icon: AnalyticsIcon,
    title: "Identify Bottlenecks",
    description:
      "Visually pinpoint queues and dropped requests instantly when capacity is reached.",
  },
  {
    icon: StorageIcon,
    title: "Diverse Components",
    description:
      "Use Databases, Load Balancers, API Servers, and Auto-Scaling Groups.",
  },
  {
    icon: MemoryIcon,
    title: "Interactive Learning",
    description:
      "Build intuition for distributed systems and master interview preparation.",
  },
];

export const Features: React.FC = () => {
  return (
    <section className="features-section">
      <div className="features-container">
        <Typography variant="h3" component="h2" className="section-title">
          Build intuition through simulation
        </Typography>
        <Typography variant="h6" className="section-subtitle">
          Packed with features designed to make system design concepts tangible
          and interactive.
        </Typography>

        <Grid container spacing={4} className="features-grid">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Grid item xs={12} sm={6} md={4} key={index} className="feature-card-wrapper">
                <Box className="feature-card">
                  <div className="feature-icon-wrapper">
                    <Icon className="feature-icon" />
                  </div>
                  <Typography variant="h6" className="feature-title">
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" className="feature-description">
                    {feature.description}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </div>
    </section>
  );
};
